import { useState, useEffect, useRef } from 'react';

// Fetches a live price from Binance public API with graceful fallback to a
// simulated random-walk if the network/region blocks the request.
export default function useLivePrice(symbol = 'BTCUSDT', seed = 71432.5, seedChange = 2.14) {
  const [price, setPrice] = useState(seed);
  const [change, setChange] = useState(seedChange);
  const [live, setLive] = useState(false);
  const liveRef = useRef(false);

  useEffect(() => {
    let stop = false;
    const controller = new AbortController();

    const fetchLive = async () => {
      // 1) CoinGecko (broad CORS + availability), 2) Binance fallback.
      try {
        const cg = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd&include_24hr_change=true', { signal: controller.signal });
        if (cg.ok) {
          const j = await cg.json();
          const p = j?.bitcoin?.usd;
          const c = j?.bitcoin?.usd_24h_change;
          if (!stop && isFinite(p)) {
            setPrice(p); setChange(isFinite(c) ? c : seedChange);
            setLive(true); liveRef.current = true;
            return;
          }
        }
      } catch (e) { /* try next */ }
      try {
        const r = await fetch(`https://api.binance.com/api/v3/ticker/24hr?symbol=${symbol}`, { signal: controller.signal });
        if (!r.ok) throw new Error('bad status');
        const d = await r.json();
        const p = parseFloat(d.lastPrice);
        const c = parseFloat(d.priceChangePercent);
        if (!stop && isFinite(p)) {
          setPrice(p); setChange(isFinite(c) ? c : seedChange);
          setLive(true); liveRef.current = true;
        }
      } catch (e) {
        // keep simulated mode
      }
    };

    fetchLive();
    const poll = setInterval(fetchLive, 12000);
    const sim = setInterval(() => {
      setPrice((prev) => prev + (Math.random() - 0.5) * (prev * 0.0006));
    }, 1500);

    return () => { stop = true; controller.abort(); clearInterval(poll); clearInterval(sim); };
  }, [symbol, seedChange]);

  return { price, change, live };
}
